export const CommodityType = {
    'None': 0,
    'AlbertaEnvironmentals': 1
}

export const MarkState = {
    "Submitted": "Submitted",
    "Rejected": "Rejected",
    "Approved": "Approved"
}

export const ForwardReportingPeriodicity = {
    "Hour": "Hour",
    "Day": "Day",
    "Week": "Week",
    "Month": "Month",
    "Year": "Year"
}

export const HistoricalReportingPeriodicity = {
    "Hour": "Hour",
    "Day": "Day",
    "Week": "Week",
    "Month": "Month",
    "Year": "Year"
}